<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-group-chat`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M34.03 23c3.82 0 6.914 3.068 6.914 6.853a6.8 6.8 0 01-1.993 4.815C42.38 35.675 45 38.876 45 42.67v.515c0 .45-.365.815-.815.815h-1.677a.815.815 0 01-.812-.74l-.021-.196c-.42-3.111-2.79-5.495-5.374-5.495h-4.62c-2.6 0-4.97 2.416-5.364 5.558l-.015.134a.815.815 0 01-.811.739h-1.676a.815.815 0 01-.815-.815v-.515c0-3.808 2.649-7.02 6.1-8.014a6.8 6.8 0 01-1.983-4.803c0-3.785 3.096-6.853 6.914-6.853zM22 4c9.717 0 17.636 7.7 17.988 17.331a9.932 9.932 0 00-4.125-1.294C34.909 13.235 29.066 8 22 8 14.268 8 8 14.268 8 22v14h12.934l-1.377 4H6a2 2 0 01-2-2V22c0-9.941 8.059-18 18-18zm12.03 22.853a3 3 0 100 6 3 3 0 000-6zM20 25a1 1 0 011 1v2a1 1 0 01-1 1h-5a1 1 0 01-1-1v-2a1 1 0 011-1h5zm8-8a1 1 0 011 1v2a1 1 0 01-1 1H15a1 1 0 01-1-1v-2a1 1 0 011-1h13z"/></svg>
</template>
<script>

export default {
  name: 'IconGroupChat',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
